<div id="divProfileContainer" class="divProfileContainer">
  <div id="divProfileInfo" class="divProfileInfo" *ngIf="currentUser">
    <span id="displayName" class="HeaderDisplayName" title="{{ currentUser.username }}">{{ currentUser.name }}</span><br />
    <span (click)="signOut()" class="HeaderSignOutButton" id="signOutButton">Sign out</span>
  </div>
</div>
